import * as types from './siteAliasActionType';

// Fetch Site Alias Management List
export const fetchSiteAliasManagementListRequest = (value = false) => ({
    type: types.FETCH_SITE_ALIAS_MANAGEMENT_REQUEST,
    payload: value
});

export const fetchSiteAliasManagementListSuccess = (data) => ({
    type: types.FETCH_SITE_ALIAS_MANAGEMENT_SUCCESS,
    payload: data
});

export const fetchSiteAliasManagementListFailure = (error) => ({
    type: types.FETCH_SITE_ALIAS_MANAGEMENT_FAILURE,
    payload: error
});

// Fetch All Sites for Site Alias Management
export const fetchAllSitesAliasRequest = () => ({
    type: types.FETCH_GETALLSITES_REQUEST
});
export const fetchAllSitesAliasSuccess = (data) => ({
    type: types.FETCH_GETALLSITES_SUCCESS,
    payload: data
});
export const fetchAllSitesAliasFailure = (error) => ({
    type: types.FETCH_GETALLSITES_FAILURE,
    payload: error
});

// Bulk Save Site Alias Management
export const bulksaveSiteAliasRequest = (data) => ({
    type: types.BULK_SAVE_SITE_ALIAS_MANAGEMANT_REQUEST,
    payload: data
});
export const bulksaveSiteAliasSuccess = (data) => ({
    type: types.BULK_SAVE_SITE_ALIAS_MANAGEMANT_SUCCESS,
    payload: data
});
export const bulksaveSiteAliasFailure = (error) => ({
    type: types.BULK_SAVE_SITE_ALIAS_MANAGEMANT_FAILURE,
    payload: error
});

// Get Site Alias Management Details history
export const sitealiasmanagementhistoryRequest = (id) => ({
    type: types.SITEALIASMANAGEMENT_DETAILS_REQUEST,
    payload: id
});

export const sitealiasmanagementhistorySuccess = (data) => ({
    type: types.SITEALIASMANAGEMENT_DETAILS_SUCCESS,
    payload: data
});

export const sitealiasmanagementhistoryFailure = (error) => ({
    type: types.SITEALIASMANAGEMENT_DETAILS_FAILURE,
    payload: error
});

// Activate/Deactivate Site Alias Management
export const activatedeactivatesitealisRequest = (Id, status, userId) => ({
    type: types.SITEALIASACTIVATEDEACTIVATE_REQUEST,
    payload: { Id, status, userId }
});

export const activatedeactivatesitealisSuccess = (data) => ({
    type: types.SITEALIASACTIVATEDEACTIVATE_SUCCESS,
    payload: data
});

export const activatedeactivatesitealisFailure = (error) => ({
    type: types.SITEALIASACTIVATEDEACTIVATE_FAILURE,
    payload: error
});  

// Export Site Alias Management
export const exportSitesAliasRequest = (payload = {}) => ({
    type: types.EXPORT_SITE_ALIAS_MANAGEMENT_REQUEST,
    payload
});
export const exportSitesAliasSuccess = (data) => ({
    type: types.EXPORT_SITE_ALIAS_MANAGEMENT_SUCCESS,
    payload: data
});
export const exportSitesAliasFailure = (error) => ({
    type: types.EXPORT_SITE_ALIAS_MANAGEMENT_FAILURE,
    payload: error
});